import Microphone01 from "@untitled-ui/icons-react/build/esm/Microphone01";
import MicrophoneOff01 from "@untitled-ui/icons-react/build/esm/MicrophoneOff01";
import { Dropdown } from "antd";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { useContext, useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useLocation, useNavigate } from "react-router";
import styled from "styled-components";
import ArchiveIcon from "../../../assets/icons/archive0.svg";
import arrowNarrowUpIcon from "../../../assets/icons/arrow-narrow-up0.svg";
import botagIconPurpleContainer from "../../../assets/icons/botag-icon-purple-container.svg";
import botagIcon from "../../../assets/icons/botag-icon-purple.svg";
import DotsHorizontalIcon from "../../../assets/icons/dots-horizontal0.svg";
import EditIcon from "../../../assets/icons/edit-050.svg";
import LogoutIcon from "../../../assets/icons/log-out-010.svg";
import paperclipIcon from "../../../assets/icons/paperclip0.svg";
import { ReactComponent as RefreshIcon } from "../../../assets/icons/refresh-ccw-010.svg";
import stopCircleIcon from "../../../assets/icons/stop-circle.svg";
import XCloseIcon from "../../../assets/icons/x-close.svg";
import { ReactComponent as XCloseIcon2 } from "../../../assets/icons/x-close1.svg";
import AppContext, { resetAIPanelStates } from "../../../contexts/AppContext";
import LayoutContext from "../../../contexts/LayoutContext";
import UserContext from "../../../contexts/UserContext";
import { formatDefaultDateTime } from "../../../utils/Formatter";
import * as Library from "../../../utils/Library";
import FullScreenLoader from "../loaders/FullScreenLoader";
import AllChatsPanel from "./AllChatsPanel";
import {
    handleToolFetchPhotoFromGallery,
    handleToolNavigateToPage,
    handleToolTakePhoto,
    handleToolOpenBOtag,
    handleToolSelectColor,
    handleToolSelectSize,
    handleToolSelectDeliveryMethod,
    handleToolSelectDeliveryPreferences,
    handleToolPurchaseWhatsOnBOtag,
    handleToolSearchFiltersWithChatGPT,
    handleToolAIfindImageMatch
} from "./ToolCallsForFrontend";
import {
    speechContainsStopListening,
    speechContainsWakeWord
    /*speechContainsFetchPhotoFromGallery,
    speechContainsOpenBotagIntent,
    speechContainsPurchaseIntent,
    speechContainsTakePhoto,
    speechContainsTakePhotoFromRaybanMeta, */
} from "./AIUtils";
import Camera01 from "@untitled-ui/icons-react/build/esm/Camera01";
import TakePhoto from "../TakePhoto";
import FullScreenOverlay from "../overlay/FullScreenOverlay";
//import CameraOff from "@untitled-ui/icons-react/build/esm/CameraOff";
//import Loading from "@untitled-ui/icons-react/build/esm/Loading01";

// #region SCOPED CSS
export const StyledChatWindowContent = styled.div`
    &.chat-window {
        transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        opacity: 0;
        transform: translateY(40px) scale(0.98);
        pointer-events: none;
        box-shadow: 0px -2px 10px 0px rgba(17, 22, 32, 0.8);
        width: 100%;
    }
    &.chat-window.isVisible {
        display: block;
        opacity: 1;
        transform: translateY(0) scale(1);
        pointer-events: auto;
    }
    &.chat-window.isHidden {
        display: block;
        opacity: 0;
        transform: translateY(40px) scale(0.98);
        pointer-events: none;
    }

    &.chat-window.full-screen,
    &.chat-window.full-screen .b-otag-ai-chat-widget {
        height: 100vh;
    }
    .b-otag-ai-chat-widget,
    .b-otag-ai-chat-widget * {
        box-sizing: border-box;
    }
    .b-otag-ai-chat-widget {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        height: 100vh;
        position: relative;
    }
    .frame-1000011421 {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 5px 5px 0px 0px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-200, #262e3e);
        border-width: 0px 0px 1px 0px;
        padding: 12px 8px 12px 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .group-2 {
        flex-shrink: 0;
        width: 94.39px;
        height: 29.6px;
        position: static;
    }
    .divlabel {
        text-align: left;
        font-family: "ItcAvantGardeGothicProMd-Regular", sans-serif;
        font-size: 18.96491050720215px;
        font-weight: 400;
        position: absolute;
        left: 42.39px;
        top: 13.8px;
    }
    .label-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .label-span2 {
        background: linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
            linear-gradient(
                199.32deg,
                rgba(96, 226, 93, 1) 28.1884104013443%,
                rgba(97, 35, 228, 1) 49.97871816158295%,
                rgba(90, 195, 254, 1) 62.99999952316284%,
                rgba(34, 255, 255, 1) 99.50000047683716%
            );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        background: linear-gradient(199deg, #60e25d -52.98%, #6123e4 6.33%, #5ac3fe 41.77%, #2ff 141.12%);
        background-clip: text;
        font-size: 18.965px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .exclusion-7 {
        width: 26.39px;
        height: 23.09px;
        position: absolute;
        left: 16px;
        top: 13.2px;
        overflow: visible;
    }
    .frame-1000011450 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .frame-110 {
        padding: 8.89px;
        display: flex;
        flex-direction: row;
        gap: 3.56px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        position: relative;
    }
    .dots-horizontal {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-113 {
        border-radius: 13332px;
        padding: 8.89px;
        display: flex;
        flex-direction: row;
        gap: 3.56px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        position: relative;
        aspect-ratio: 1;
    }
    .component-1 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-112 {
        padding: 8.89px;
        display: flex;
        flex-direction: row;
        gap: 3.56px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        position: relative;
    }
    .x-close {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .all-messages-container {
        background: var(--backgrounds-and-lines-n-500, #141922);
        padding: 24px 16px;
        display: block;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-end;
        align-self: stretch;
        flex: 1;
        position: relative;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .all-messages-container::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }
    .message-container {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        margin-top: 24px;
    }
    .user-icon {
        //display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        height: auto;
        position: absolute;
        overflow: visible;
        align-self: flex-start;
        z-index: 99;
        top: -25px;
        border: solid 3px var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 50px;
    }
    .user-icon.user {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        object-fit: cover;
        overflow: hidden;
    }

    .message-date-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 300px;
        position: relative;
    }
    .message-ballon {
        background: #1e2631;
        border-radius: 16px;
        padding: 10px 15px 10px 15px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        min-height: 20px;
        max-width: 100%;
    }
    .message-ballon img {
        max-width: 100%;
        height: auto;
    }
    .message-text-style {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        min-height: 20px;
        max-width: 100%;
        overflow-x: auto;
    }
    .loading-placeholder {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .message-datetime {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        margin-top: 8px;
    }
    .message-datetime-style {
        color: var(--backgrounds-and-lines-n-100, #3c485a);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
    }
    .frame-1000011416 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-200, #262e3e);
        border-width: 1px 0px 0px 0px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        //position: absolute;
        //left: 50%;
        //translate: -50%;
        bottom: 0px;
    }
    .frame-1000011411 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }
    .frame-1000011407 {
        border-radius: 16px;
        //border-style: solid;
        border-color: #5d3fd3;
        border-width: 1px;
        //padding: 10px 8px 10px 8px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }
    .frame-1000011423 {
        background: #5d3fd3;
        border-radius: 16px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        position: relative;
        max-width: 100%;
        min-width: 0;
    }
    .frame-10000114232 {
        //background: #5d3fd3;
        border-radius: 16px;
        //padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        //width: 36px;
        //height: 36px;
        position: relative;
        max-width: 100%;
        min-width: 0;
    }
    .file-06 {
        flex-shrink: 0;
        width: 100%;
        //height: 18px;
        position: relative;
        //overflow: visible;
        border-radius: 16px;
        //aspect-ratio: 1;
    }
    .frame-1000011422 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 1;
        position: relative;
        width: 100%;
        max-width: 100%;
        min-width: 0;
    }
    .replay-xlsx {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        max-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex-shrink: 1;
        width: 100%;
        overflow: hidden;
        max-width: 100%;
    }
    .file {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
    }
    .frame-1000011448 {
        background: var(--primary-white-500, #ffffff);
        border-radius: 9999px;
        padding: 4px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: absolute;
        top: -6px;
        right: -6px;
        cursor: pointer;
        color: #000000;
    }
    .x-close2 {
        border-radius: 9999px;
        flex-shrink: 0;
        width: 11px;
        height: 11px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        color: var("--backgrounds-and-lines-n-600");
    }
    .frame-10000114072 {
        background: #1e2631;
        border-radius: 16px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 100%;
        position: relative;
    }
    .frame-111 {
        border-radius: 9999px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-200, #262e3e);
        border-width: 1px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        position: relative;
        align-self: self-end;
    }
    .frame-111.active {
        border-color: #5d3fd3;
        background: #5d3fd3;
    }
    .frame-111.stop-listening {
        border-color: var(--backgrounds-and-lines-n-200, #262e3e);
        background: var(--backgrounds-and-lines-n-200, #262e3e);
    }
    .paperclip {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .text-user {
        color: var(--text-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        flex: 1;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        //remove input default styles
        border: none;
        outline: none;
        background: transparent;
        padding: 0;
    }
    .frame-1102 {
        background: var(--text-and-icons-gray-100, #d1d1d1);
        border-radius: 16px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        position: relative;
        aspect-ratio: 1;
        align-self: self-end;
    }
    .arrow-narrow-up {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .powered-by-chat-gpt {
        color: var(--backgrounds-and-lines-n-100, #3c485a);
        text-align: center;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }

    // --------------------
    .disabled-icon {
        opacity: 0.3;
        pointer-events: none;
    }
    .old-message {
        opacity: 1;
        transform: translateY(0);
        transition: opacity 0.4s, transform 0.4s;
    }
    .new-message {
        opacity: 0;
        transform: translateY(20px);
        animation: fadeInMessage 0.4s forwards;
    }
    @keyframes fadeInMessage {
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    // --------------------
    .message-container.user {
        flex-direction: row-reverse;
    }
    .message-container.user .message-date-container-sized {
        align-self: flex-end;
        max-width: 100%;
        overflow: hidden;
    }
    .message-container.user .message-ballon {
        background: #5d3fd3;
    }
    .message-container.user .message-datetime {
        justify-content: flex-end;
    }

    .message-loading {
        display: inline-block;
        width: 42px;
        position: relative;
        text-align: center;
    }
    .message-loading-dot {
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #d1d1d1;
        border-radius: 50%;
        position: relative;
        animation: messageLoadingBounce 1s infinite alternate;
    }
    .message-loading-dot:nth-child(2) {
        left: 5px;
        animation-delay: 0.5s;
    }
    @keyframes messageLoadingBounce {
        0% {
            transform: translateY(0);
            opacity: 0.5;
        }
        50% {
            transform: translateY(-6px);
            opacity: 1;
        }
        100% {
            transform: translateY(0);
            opacity: 0.5;
        }
    }

    // --------------------
    .table-list-action-dropdown-normal {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 161px;
        position: relative;
        box-shadow: var(--drop-shadow-100-box-shadow, 0px 0px 10px 0px rgba(17, 22, 32, 1));
    }
    .frame-74 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    &.frame-79 {
        border-radius: 4px;
        padding: 10px 8px 10px 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    &.frame-79:hover {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
    }
    .edit-05 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .new-chat {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        flex: 1;
        height: 16px;
        line-height: 16px;
    }

    .ant-dropdown-menu {
        width: 161px !important;
    }

    p {
        margin: 0;
        padding: 0;
    }
`;

const StyledDialogue = styled.div`
    &.dialog-box,
    &.dialog-box * {
        box-sizing: border-box;
        z-index: 9999;
    }
    &.dialog-box {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        padding: 16px 24px 16px 24px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        width: 286px;
        position: relative;
        box-shadow: var(--drop-shadow-200-box-shadow, 0px 0px 48.1px 0px rgba(17, 22, 32, 0.51));
        justify-self: center;
        position: absolute;
        top: 195px;
        left: 37px;
    }
    .frame-257 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .attention {
        color: var(--text-and-icons-red-500, #ff3636);
        text-align: center;
        font-family: var(--label-small-uppercase-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--label-small-uppercase-font-size, 10px);
        line-height: var(--label-small-uppercase-line-height, 5px);
        letter-spacing: var(--label-small-uppercase-letter-spacing, 0.0125em);
        font-weight: var(--label-small-uppercase-font-weight, 500);
        text-transform: uppercase;
        position: relative;
        align-self: stretch;
    }
    .line-4 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-200, #262e3e);
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-258 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-285 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-160 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-286 {
        padding: 0px 32px 0px 32px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .ready-to-delete {
        color: #ffffff;
        text-align: center;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 18px;
        font-weight: 700;
        position: relative;
        flex: 1;
    }
    .it-will-be-gone-forever {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-family: var(--subtitle-2-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        align-self: stretch;
    }
    .frame-255 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-large-solid-inverted-01 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        cursor: pointer;
    }
    .btn-small-filled {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 35px;
        position: relative;
    }
    .share {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--button-text-large-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--button-text-large-font-size, 12px);
        letter-spacing: var(--button-text-large-letter-spacing, 0.0125em);
        font-weight: var(--button-text-large-font-weight, 400);
        text-transform: uppercase;
        position: relative;
    }
`;
// #endregion

/** ChatWindow renders a chat interface with messages exchanged between the user and a bot.
 * @component
 * @param {Object} props - Component props.
 * @param {boolean} props.isSidePanelFullScreen - Whether the chat window is in full screen mode for side panel.
 * @returns {JSX.Element} The rendered chat window with messages and input field.
 */
export default function ChatWindow(props) {
    // #region VARS
    const { isSidePanelFullScreen } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const [userInputText, setUserInputText] = useState("");

    const {
        aiChatLoading,
        aiChatIsVisible,
        aiChatSidePanelOpen,
        //setAiChatSidePanelOpen,
        aiChatWindowOpen,
        //setAiChatWindowOpen,
        showChatConversation,
        setShowChatConversation,
        showChatAllPanel,
        setShowChatAllPanel,
        aiChatMessages,
        setAiChatMessages,
        setAiChatLoading,
        fileUpload,
        setFileUpload,
        aiChatFetchingReply,
        setAiChatFetchingReply,
        replaceCurrentBotMessage,
        setReplaceCurrentBotMessage,
        botagToPurchaseData,
        setIsLoadingApp,
        BOTagsList,
        //setSelectedHomePageBotagId,
        selectedBotag,
        aiChatCurrentThreadID,
        setAiChatCurrentThreadID,
        setSelectedBotag,
        setAiSelectedNewSize,
        setAiSelectedNewColor,
        setAiSelectedNewDeliveryMethod,
        setAiOpenBOtag
    } = useContext(AppContext);

    const appContext = useContext(AppContext);

    const {
        setPaymentPopupData,
        setShowThankyouPopup,
        setShowBOImagePageID,
        setShowRightUserLocationPanel,
        setOrderID,
        setShowTakePhotoPopup,
        AIPanelNewFacebookPhoto,
        setAIPanelNewFacebookPhoto
    } = useContext(LayoutContext);
    const { setThankYouAmount, isUserLoggedIn, userData, BOTagAccountID, checkoutPaymentData } = useContext(UserContext);
    //const appContext = useContext(AppContext);

    const { setShowRightAiPanel, setDeliveryPreference } = useContext(LayoutContext);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [textAreaHeight, setTextAreaHeight] = useState("auto");
    //const [openBOTag, setOpenBOTag] = useState(null);
    const [previewPhoto, setPreviewPhoto] = useState(null);

    const userCoords = JSON.parse(localStorage.getItem("userCoords") ?? "{}")?.coords;
    const userLocation = JSON.parse(localStorage.getItem("userLocation") ?? "{}")?.location;

    // ------------------- STATES FOR EVENT HANDLING ----------------------
    const [shouldStartBuyProduct, setShouldStartBuyProduct] = useState(false);
    const [triggerAddNewMessage, setTriggerAddNewMessage] = useState(null);
    const [triggerPromptAIRequest, setTriggerPromptAIRequest] = useState(null);
    const [triggerTextToSpeechMessage, setTriggerTextToSpeechMessage] = useState(null);

    // ----------------------- RECOGNITION & VISION -----------------------
    const [isRecognizing, setIsRecognizing] = useState(false);
    const recognizerRef = useRef(null);
    // #endregion

    // #region METHODS
    const addNewMessage = message => {
        setAiChatMessages(prevMessages => [...prevMessages, message]);
    };

    const userAddNewMessage = () => {
        if (aiChatFetchingReply) return;

        if (showChatAllPanel) {
            const newMessageText = "Hello there! Let's BO shopping!";

            setShowChatConversation(true);
            setShowChatAllPanel(false);
            setAiChatMessages([
                {
                    id: 1,
                    text: newMessageText,
                    sender: "bot",
                    timestamp: new Date(),
                    isLoadingMessage: !showChatAllPanel,
                    loadingPlaceholder: fetchLoadingPlaceholderMessage(4),
                    fileUpload: null
                }
            ]); // Clear messages for new chat
            //textToSpeech(newMessageText);
        }

        if (!userInputText.trim()) {
            Library.showToastMessage({
                type: "warning",
                message: "Please enter a message before sending.",
                autoClose: 2000
            });
            return; // Prevent sending empty messages
        }
        const currentID = aiChatMessages.length + 1;

        const newMessage = {
            id: currentID,
            text: userInputText,
            sender: "user",
            timestamp: new Date(),
            isLoadingMessage: false,
            fileUpload: fileUpload
        };

        addNewMessage(newMessage);
        setUserInputText(""); // Clear input after sending

        promptAIRequest({
            message: userInputText,
            newID: currentID + 1
        });
    };

    /* const expandButtonClicked = () => {
        const newIsSidePanelVisible = !aiChatSidePanelOpen;
        setAiChatSidePanelOpen(newIsSidePanelVisible);

        const newaiChatWindowOpen = !newIsSidePanelVisible;
        setAiChatWindowOpen(newaiChatWindowOpen);
    }; */

    const isWindowVisible = () => {
        if (!aiChatIsVisible) return false;
        return isSidePanelFullScreen ? aiChatSidePanelOpen : aiChatWindowOpen;
    };

    const updateMessage = ({ messageID, newText, isLoading = false, shouldScrollToMessage = true, delayMessageTimeout = 0 }) => {
        setTimeout(() => {
            setAiChatMessages(prevMessages => {
                const updatedMessages = [...prevMessages];
                const messageIndex = updatedMessages.findIndex(msg => msg.id === messageID);
                if (messageIndex !== -1) {
                    updatedMessages[messageIndex] = {
                        ...updatedMessages[messageIndex],
                        text: newText,
                        isLoadingMessage: isLoading
                    };

                    setTriggerTextToSpeechMessage(newText);
                }

                // Scroll to the updated message if requested
                if (shouldScrollToMessage) {
                    scrollToMessage(messageID);
                }
                return updatedMessages;
            });
        }, delayMessageTimeout);
    };

    const scrollToMessage = messageID => {
        setTimeout(() => {
            const messageElements = document.getElementsByClassName(`chat-message-${messageID}`);
            if (messageElements.length > 0) messageElements[0].scrollIntoView({ behavior: "smooth", block: "nearest" });
        }, 100); // Delay to ensure the DOM is updated
    };

    const convertFileToBase64 = file => {
        return new Promise((resolve, reject) => {
            //check if file is already a base64 string
            if (typeof file === "string" && file.startsWith("data:")) {
                resolve(file);
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };

    const convertUrlToBase64 = async url => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            return new Promise((resolve, reject) => {
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        } catch (error) {
            console.error("Error converting URL to base64:", error);
            return null;
        }
    };

    const promptAIRequest = async ({ message, newID }) => {
        const currentID = newID;
        const isUploadingFile = !!fileUploadRef?.current?.file;
        //const endpointName = Library.isLocalhost("promptAIchat") ? "searchFiltersWithChatGPT" : "searchFiltersWithChatGPT";
        //const endpointName = isUploadingFile ? "AIfindImageMatch" : "promptAIchat";
        const endpointName = "promptAIchat";

        try {
            const imageData = isUploadingFile
                ? {
                      base64: await convertFileToBase64(fileUploadRef?.current?.file),
                      name: fileUploadRef?.current?.fileName
                  }
                : null;

            const appContext = {
                uiPage: location.pathname,
                botagIsOpen: !!selectedBotag,
                BOTagsList: BOTagsList,
                availableSizes: selectedBotag?.sizes || [],
                availableColors: selectedBotag?.colors?.map(c => c?.color) || [],
                userIsUploadingPhoto: isUploadingFile,
                productID: selectedBotag?.productID || selectedBotag?.data?.productObjID,
                productName: selectedBotag?.productName,
                productType: selectedBotag?.productType
            };

            const formData = {
                promptText: message,
                threadID: aiChatCurrentThreadID,
                //uploadedFiles: isUploadingFile,
                imageData: imageData,
                BOthebotAccountID: BOTagAccountID,
                appContext
            };

            const newMessage = {
                id: currentID,
                text: "...",
                sender: "bot",
                timestamp: new Date(),
                isLoadingMessage: true,
                loadingPlaceholder: fetchLoadingPlaceholderMessage()
            };
            removeFileUpload(); // Clear file upload state
            addNewMessage(newMessage);
            scrollToMessage(currentID);

            const res = await Library.makeApiRequest({
                endpoint: endpointName,
                data: formData,
                onError: error => {
                    updateMessage({
                        messageID: currentID,
                        newText: error?.message
                            ? error?.message
                            : "There was an error trying to get a response from the AI. Please try again later.",
                        delayMessageTimeout: 500,
                        shouldScrollToMessage: true
                    });
                    // setTriggerAddNewMessage({
                    //     id: aiChatMessagesRef.current.length + 1,
                    //     sender: "bot",
                    //     text: error?.message
                    //         ? error?.message
                    //         : "There was an error trying to get a response from the AI. Please try again later.",
                    //     timestamp: new Date()
                    // });
                },
                setLoader: setAiChatFetchingReply
            });
            if (res?.data?.status !== 200) throw new Error(`Error: ${res?.data?.message || "Server response error."}`);

            const aiResponse = res?.data?.data?.reply;
            const toolCallsForFrontend = res?.data?.data?.toolCallsForFrontend || [];
            const threadID = res?.data?.data?.threadID;
            //let bypassAiResponse = undefined;

            if (toolCallsForFrontend.length > 0) {
                if (Library.isLocalhost("promptAIchat", true))
                    console.warn(
                        "Tool calls for frontend:",
                        toolCallsForFrontend?.map(call => call?.functionName)
                    );

                /* #region CHECK TOOL CALLS */
                const navigateToPageCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "navigateToPage".toLowerCase()
                );
                const takePhotoCall = toolCallsForFrontend.find(call => call.functionName.toLowerCase() === "takePhoto".toLowerCase());
                const fetchPhotoFromGalleryCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "fetchPhotoFromGallery".toLowerCase()
                );
                const openBOtagCall = toolCallsForFrontend.find(call => call.functionName.toLowerCase() === "openBOtag".toLowerCase());
                const selectColorCall = toolCallsForFrontend.find(call => call.functionName.toLowerCase() === "selectColor".toLowerCase());
                const selectSizeCall = toolCallsForFrontend.find(call => call.functionName.toLowerCase() === "selectSize".toLowerCase());
                const selectDeliveryPreferencesCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "selectDeliveryPreferences".toLowerCase()
                );
                const selectDeliveryMethodCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "selectDeliveryMethod".toLowerCase()
                );
                const purchaseWhatsOnBOtagCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "purchaseWhatsOnBOtag".toLowerCase()
                );
                const searchFiltersWithChatGPTCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "searchFiltersWithChatGPT".toLowerCase()
                );
                const AIfindImageMatchCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "AIfindImageMatch".toLowerCase()
                );
                /* #endregion */

                /*if (navigateToPageCall) {
                    if (location.pathname !== "/" && location.pathname !== "/search") {
                        const botMessage =
                            "Apologies, I can't process that request here. Would you mind repeating or clarifying what you need?";
                        updateMessage({ messageID: currentID, newText: botMessage, isLoading: false, shouldScrollToMessage: true });
                        return;
                    }

                    bypassAiResponse = navigateToPage(navigateToPageCall?.functionParams, { navigate, location });
                }*/

                const generalExtraParams = {
                    navigate,
                    location,
                    setTriggerAddNewMessage,
                    appContext,
                    setShowTakePhotoPopup,
                    setUserInputText,
                    handleUploadClick,
                    setShouldStartBuyProduct,
                    setSelectedBotag,
                    setAiSelectedNewSize,
                    setAiSelectedNewColor,
                    setDeliveryPreference,
                    setAiSelectedNewDeliveryMethod,
                    setAiOpenBOtag
                };

                if (navigateToPageCall) handleToolNavigateToPage(navigateToPageCall?.functionParams, { ...generalExtraParams });
                if (takePhotoCall) handleToolTakePhoto(takePhotoCall?.functionParams, { ...generalExtraParams });
                if (fetchPhotoFromGalleryCall)
                    handleToolFetchPhotoFromGallery(fetchPhotoFromGalleryCall?.functionParams, { ...generalExtraParams });
                if (openBOtagCall) handleToolOpenBOtag(openBOtagCall?.functionParams, { ...generalExtraParams });
                if (selectColorCall) handleToolSelectColor(selectColorCall?.functionParams, { ...generalExtraParams });
                if (selectSizeCall) handleToolSelectSize(selectSizeCall?.functionParams, { ...generalExtraParams });
                if (selectDeliveryPreferencesCall)
                    handleToolSelectDeliveryPreferences(selectDeliveryPreferencesCall?.functionParams, { ...generalExtraParams });
                if (selectDeliveryMethodCall)
                    handleToolSelectDeliveryMethod(selectDeliveryMethodCall?.functionParams, { ...generalExtraParams });
                if (purchaseWhatsOnBOtagCall)
                    handleToolPurchaseWhatsOnBOtag(purchaseWhatsOnBOtagCall?.functionParams, { ...generalExtraParams });
                if (searchFiltersWithChatGPTCall)
                    handleToolSearchFiltersWithChatGPT(searchFiltersWithChatGPTCall?.functionParams, { ...generalExtraParams });
                if (AIfindImageMatchCall) handleToolAIfindImageMatch(AIfindImageMatchCall?.functionParams, { ...generalExtraParams });
            }

            if (threadID) setAiChatCurrentThreadID(threadID);
            //if (!aiResponse && !bypassAiResponse) throw new Error("AI response is empty or undefined.");

            const finalAIResponse = aiResponse || "AI response was empty or undefined. Please try again.";

            updateMessage({ messageID: currentID, newText: finalAIResponse, isLoading: false, shouldScrollToMessage: true });
        } catch (error) {
            const errorText = error?.message ? error?.message : "We couldn't fetch a response from the AI. Please try again later.";
            const finalAIResponse = `An error has occurred: ${errorText}`;
            console.error("promptAIRequest error:", error);
            updateMessage({ messageID: currentID, newText: finalAIResponse, isLoading: false, shouldScrollToMessage: true });

            /* setTriggerAddNewMessage({
                id: aiChatMessagesRef.current.length + 1,
                sender: "bot",
                text: error?.message ? error?.message : "There was an error trying to get a response from the AI. Please try again later.",
                timestamp: new Date()
            });*/
        }
    };

    const textToSpeech = text => {
        const YourSpeechKey = process.env.REACT_APP_AZURE_AI_SPEECH_KEY;
        const YourSpeechRegion = process.env.REACT_APP_AZURE_AI_SPEECH_REGION;

        const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(YourSpeechKey, YourSpeechRegion);
        speechConfig.speechSynthesisVoiceName = "en-US-JasonNeural";
        const audioConfig = SpeechSDK.AudioConfig.fromDefaultSpeakerOutput();

        const speechVoice = new SpeechSDK.SpeechSynthesizer(speechConfig, audioConfig);

        speechVoice.speakTextAsync(
            `${text}`,
            result => {
                if (result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted) {
                    // SUCCESS: audio was outputted
                    console.log("Speech synthesis succeeded.", text);
                } else {
                    // FAIL:
                    console.error("Error on outputting audio: ", result.errorDetails);
                }
            },
            err => console.error("Error on speaking function: " + err)
        );
    };

    const updateAIchatRequest = async (threadID, name, status) => {
        const formData = {
            threadID,
            name,
            status
        };
        //const res = await Library.makePostRequest("updateAIchat", formData, false, setAiChatLoading);
        const res = await Library.makeApiRequest({
            endpoint: "updateAIchat",
            data: formData,
            setLoader: setAiChatLoading
        });

        if (res?.data?.status !== 200) return false;

        return true;
    };

    const handleNewChat = (showConversation = true) => {
        //const userName = localStorage.getItem("userFirstName") || localStorage.getItem("userLastName") || "User";
        setShowChatConversation(showConversation);
        setShowChatAllPanel(false);
        removeFileUpload();
        setUserInputText("");

        resetAIPanelStates(appContext);

        const newMessageText = "Hello there! Let's BO shopping!";
        setAiChatMessages([
            {
                id: 1,
                text: newMessageText,
                sender: "bot",
                timestamp: new Date(),
                isLoadingMessage: true,
                loadingPlaceholder: fetchLoadingPlaceholderMessage(4)
            }
        ]); // Clear messages for new chat
        // textToSpeech(newMessageText);
        setTriggerTextToSpeechMessage(newMessageText);
    };

    const fetchLoadingPlaceholderMessage = (index = null) => {
        const placeholders = [
            "processing",
            "thinking",
            "working on it",
            "this may take a bit",
            "just a moment",
            "processing your request",
            "let me check that for you",
            "gathering information",
            "analyzing your input",
            "please hold on",
            "fetching data",
            "loading response",
            "almost there",
            "just a sec",
            "getting things ready",
            "one moment please",
            "looking into that",
            "checking details"
        ];

        //if index is provided, return that specific placeholder else return random
        if (typeof index === "number" && index >= 0 && index < placeholders.length) return placeholders[index];

        const randomIndex = Math.floor(Math.random() * placeholders.length);
        return placeholders[randomIndex];
    };

    const handleUploadClick = () => {
        const fileInput = document.querySelector("#file-upload-input");
        if (fileInput) {
            fileInput.click(); // Trigger file input click
        } else {
            Library.showToastMessage({
                type: "warning",
                message: "File upload input not found.",
                autoClose: 2000
            });
        }
    };

    /* const previewPhotoPopup = () => {
        //setShowTakePhotoPopup(true);
        setPreviewPhoto(true);
    }; */

    const handleCameraClick = () => {
        setShowTakePhotoPopup(true);
        //setPreviewPhoto(true);
    };

    const handleFileChange = file => {
        if (!file) return;

        // use regular expression to check for valid file extensions
        //const fileExtMatch = file.name.match(/\.(xls|xlsx|csv)$/i);
        const fileExtMatch = file.name.match(/\.(jpg|jpeg|png|gif|bmp|tiff|webp)$/i);

        if (!fileExtMatch) {
            Library.showToastMessage({
                type: "warning",
                message: "Please upload a valid image file.",
                autoClose: 2000
            });
            return;
        }

        convertFileToBase64(file).then(fileBase64 => {
            if (!fileBase64) {
                Library.showToastMessage({
                    type: "error",
                    message: "Failed to convert file to base64.",
                    autoClose: 2000
                });
                return;
            }
            const fileName = file.name;

            setFileUpload({
                file: fileBase64,
                fileName: fileName
            });
        });
    };

    const removeFileUpload = () => {
        setFileUpload({ file: null, fileName: null });
        const fileInput = document.querySelector("#file-upload-input");
        if (fileInput) {
            fileInput.value = ""; // Clear the file input value
        }
    };

    const handleCloseChat = () => {
        //setAiChatSidePanelOpen(false);
        //setAiChatWindowOpen(false);
        setShowRightAiPanel(false);
    };
    // #endregion

    // #region METHODS FOR PURCHASING
    const getAllPurchaseData = async () => {
        //const mock genericData
        const genericPurchaseData = {
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: userData.email,
            customerId: checkoutPaymentData.customerID,
            mobileNumber: userData.phone,
            paymentMethod: checkoutPaymentData.paymentMethodID,
            bothebotAccountId: BOTagAccountID,
            selectedPaymentType: "CARD"
        };

        let productsData;

        try {
            const address =
                (userLocation.street ?? "") +
                " " +
                (userLocation.streetNumber ?? "") +
                ", " +
                (userLocation.postCode ?? "") +
                " " +
                (userLocation.city ?? "") +
                ", " +
                (userLocation.country ?? "");

            if (
                !botagToPurchaseData ||
                !botagToPurchaseData?.deliveryData?._id ||
                !botagToPurchaseData?.productInfo?._id ||
                !botagToPurchaseData?.brandInfo?._id
            ) {
                throw new Error("Incomplete data for purchase. Try to select the product again.");
            }

            productsData = [
                {
                    companyObjID: botagToPurchaseData.deliveryData.storeDetail.companyObjID,
                    GTINbarcode: botagToPurchaseData.GTINbarcode,
                    storeID: botagToPurchaseData.deliveryData.storeDetail._id,
                    productname: botagToPurchaseData.productInfo.name,
                    itemPrice: botagToPurchaseData.deliveryData.price,
                    isDiscount: botagToPurchaseData.deliveryData.discountPrice ? true : false,
                    originalItemPrice: botagToPurchaseData.deliveryData.price,
                    deliveryCost: botagToPurchaseData.deliveryData.deliveryCharges,
                    deliveryOption: botagToPurchaseData.deliveryData.type,
                    deliveryMethod: botagToPurchaseData.deliveryData.type,
                    deliveryPreferences: botagToPurchaseData.deliveryPreference,
                    quantity: botagToPurchaseData.selectedQuantity,
                    //BOimageID: "68bfdb3460224cce4c9229d3",
                    deliveryID:
                        typeof botagToPurchaseData.deliveryData.cf === "object" && botagToPurchaseData.deliveryData.cf !== null
                            ? botagToPurchaseData.deliveryData.cf._id
                            : undefined,

                    brandID: botagToPurchaseData.brandInfo._id,
                    brandName: botagToPurchaseData.brandInfo.name,
                    userLocation: {
                        address: address,
                        country: userLocation.country,
                        latitude: userCoords.latitude,
                        longitude: userCoords.longitude
                    }
                }
            ];
        } catch (e) {
            console.error("Error preparing products data for purchase:", e);
            throw new Error("Error preparing products data for purchase:", e);
        }

        //createStripePaymentRequest data:
        const createStripePaymentData = {
            data: productsData.map(product => ({
                storeID: product.storeID,
                companyObjID: product.companyObjID,
                totalPrice: product.itemPrice * product.quantity + (product.deliveryCost || 0), //100 * 1 + 190 = 290
                type: product.deliveryMethod, //courier
                name: product.productname, //"Acr",
                quantity: product.quantity, //1
                deliveryCharges: product.deliveryCost //190
            })),
            email: genericPurchaseData.email,
            name: genericPurchaseData.firstName || genericPurchaseData.lastName,
            customerId: genericPurchaseData.customerId,
            paymentType: genericPurchaseData.selectedPaymentType
        };

        //handleTransfers data:
        const handleTransfersData = {
            paymentMethod: genericPurchaseData.paymentMethod,
            bothebotAccountId: genericPurchaseData.bothebotAccountId,
            customerId: genericPurchaseData.customerId,
            selectedPaymentType: genericPurchaseData.selectedPaymentType
        };

        //handleCreateOrder data:
        const handleCreateOrderData = {
            firstName: genericPurchaseData.firstName,
            lastName: genericPurchaseData.lastName,
            email: genericPurchaseData.email,
            mobileNumber: genericPurchaseData.mobileNumber,
            items: productsData,
            accountID: genericPurchaseData.bothebotAccountId
        };

        const popupData = {
            firstName: genericPurchaseData.firstName,
            lastName: genericPurchaseData.lastName,
            email: genericPurchaseData.email,
            phoneNumber: genericPurchaseData.mobileNumber,
            nameOnCard: genericPurchaseData.firstName,
            amount: productsData.reduce((total, product) => total + product.itemPrice * product.quantity + (product.deliveryCost || 0), 0)
        };

        return { createStripePaymentData, handleTransfersData, handleCreateOrderData, popupData };
    };

    const handleCreateStripePayment = async (data, setLoader) => {
        const res = await Library.makeApiRequest({
            endpoint: "createStripePayment",
            data: data,
            setLoader
        });

        return res;
    };

    const handleTransfers = async (data, setLoader) => {
        const res = await Library.makeApiRequest({
            endpoint: "handleTransfers",
            data: data,
            setLoader
        });

        return res;
    };

    const handleCreateOrder = async (data, setLoader) => {
        const res = await Library.makeApiRequest({
            endpoint: "createNewOrder",
            data: data,
            setLoader
        });

        return res;
    };

    const handleBuyProduct = async () => {
        try {
            setIsLoadingApp(true);
            let newMessageText = "--";
            const canContinue =
                !!botagToPurchaseData &&
                !!botagToPurchaseData?.deliveryData?._id &&
                !!botagToPurchaseData?.productInfo?._id &&
                !!botagToPurchaseData?.brandInfo?._id &&
                !!userCoords &&
                !!userLocation;
            const hasCheckoutData = checkoutPaymentData?.customerID && checkoutPaymentData?.paymentMethodID;

            if (!isUserLoggedIn) newMessageText = "Need to be logged in to buy";
            else if (!canContinue) newMessageText = "Missing purchase data or user location";
            else if (!hasCheckoutData) newMessageText = "Please set up your payment method in checkout first.";
            else newMessageText = "Creating a new order for you. Please wait...";

            setTimeout(() => {
                const newMessage = {
                    id: aiChatMessagesRef.current.length + 1,
                    text: newMessageText,
                    sender: "bot",
                    timestamp: new Date()
                };
                //addNewBotDelayedMessage(newMessage, 1000);
                setTriggerAddNewMessage(newMessage);
            }, 500);

            if (!isUserLoggedIn || !canContinue || !hasCheckoutData) {
                setIsLoadingApp(false);
                return;
            }

            const { createStripePaymentData, handleTransfersData, handleCreateOrderData, popupData } = await getAllPurchaseData();

            const res = await handleCreateStripePayment(createStripePaymentData);
            if (res?.data?.status !== 200) {
                setIsLoadingApp(false);
                return;
            }

            const stripePaymentRes = res?.data?.paymentIntent;
            handleTransfersData.uuid = stripePaymentRes?.transfer_group;
            handleTransfersData.paymentIntentId = stripePaymentRes?.id;
            handleTransfersData.connectedAccounts = res?.data?.connectedAccounts;

            const res2 = await handleTransfers(handleTransfersData);
            if (res2?.data?.status !== 200) {
                Library.showToastMessage({
                    type: "error",
                    message: "There was an error trying to create stripe transfer. Please try again later."
                });

                setIsLoadingApp(false);
                return;
            }

            handleCreateOrderData.stripeUpdateResponse = res2?.data?.updateResponse;
            handleCreateOrderData.cardCredentials = res2?.data?.cardCredentials;
            handleCreateOrderData.cardDetail = res2?.data?.cardDetail;

            //are these needed:
            handleCreateOrderData.cardName = ""; //res2?.data?.cardCredentials?.cardName;
            handleCreateOrderData.cardNumber = res2?.data?.cardCredentials?.cardNumber;
            handleCreateOrderData.cardExpireDate = ""; //res2?.data?.cardCredentials?.cardExpDate;
            handleCreateOrderData.cardCVV = res2?.data?.cardCredentials?.cardCVV;

            const res3 = await handleCreateOrder(handleCreateOrderData);
            if (res3?.data?.status !== 200) {
                Library.showToastMessage({
                    type: "error",
                    message: "There was an error trying to create the order. Please try again later."
                });

                setIsLoadingApp(false);
                return;
            }

            //After purchase thank you popup
            const paymentPopupData = {
                firstName: popupData.firstName,
                lastName: popupData.lastName,
                email: popupData.email,
                phoneNumber: popupData.phoneNumber,
                nameOnCard: popupData.nameOnCard
            };
            const amount = popupData.amount;

            setPaymentPopupData(paymentPopupData);
            setThankYouAmount(amount);
            setShowThankyouPopup(true);

            navigate("/explore");
            setShowBOImagePageID(false);
            setShowRightUserLocationPanel(false);
            setOrderID(res3?.data?.orderID || null);
            setShowRightAiPanel(false);
            handleNewChat();
        } catch (e) {
            console.error("Error in handleBuyProduct:", e);

            Library.showToastMessage({
                type: "error",
                message: "There was an unexpected error during the purchase process. Please try again later."
            });
        } finally {
            setIsLoadingApp(false);
        }
    };
    // #endregion

    // #region METHODS FOR RECOGNITIONS
    const speechRecognizingFunction = (s, e) => {
        if (e.result.reason !== SpeechSDK.ResultReason.RecognizingSpeech) return;
        console.log(`RECOGNIZING AI Panel: ${e.result.text}`);

        if (recognizerRef.current && e.result.text && e.result.text !== "" && isRecognizingRef.current && !aiChatFetchingReplyRef.current)
            setUserInputText(e.result.text);
    };

    const speechRecognizedFunction = (s, e) => {
        //IMPORTANT REMINDER: ALL STATE CHANGES IN THIS FUNCTION MUST USE REFS TO GET THE LATEST STATE VALUES!!!
        if (e.result.reason !== SpeechSDK.ResultReason.RecognizedSpeech) return;
        const resultText = e.result.text;
        if (!resultText) return;

        if (!isRecognizingRef.current) {
            if (speechContainsWakeWord(resultText)) {
                console.log("Wake word detected!");
                setIsRecognizing(true);
            }

            return;
        }

        if (aiChatFetchingReplyRef.current) {
            console.log("AI chat is fetching a reply, ignoring user input.");
            return;
        }

        setTriggerAddNewMessage({
            id: aiChatMessagesRef.current.length + 1,
            text: resultText,
            sender: "user",
            timestamp: new Date(),
            isLoadingMessage: false,
            fileUpload: fileUploadRef.current
        });

        // #region Check for special intents
        if (speechContainsStopListening(resultText)) {
            console.log("Stop listening detected!");

            //add bot message:
            setTriggerAddNewMessage({
                id: aiChatMessagesRef.current.length + 1,
                text: "Voice recognition stopped.",
                sender: "bot",
                timestamp: new Date(),
                isLoadingMessage: false,
                fileUpload: fileUploadRef.current
            });

            //stopVoiceInput();
            setIsRecognizing(false);
            setUserInputText("");
            return;
        }
        // #endregion

        const promptRequestText = {
            message: resultText,
            newID: aiChatMessagesRef.current.length + 2
        };
        setTriggerPromptAIRequest(promptRequestText);

        setUserInputText("");
    };

    const startVoiceInput = (startRecognizing = true) => {
        // If is localhost do not start voice input
        if (Library.isLocalhost("startVoiceAIPanel")) return;

        // Stop any existing recognizer before starting a new one
        if (recognizerRef.current) {
            recognizerRef.current.stopContinuousRecognitionAsync(() => {
                recognizerRef.current.close();
                recognizerRef.current = null;
            });
        }

        const azureKey = process.env.REACT_APP_AZURE_AI_SPEECH_KEY;
        const azureRegion = process.env.REACT_APP_AZURE_AI_SPEECH_REGION;

        const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(azureKey, azureRegion);
        speechConfig.speechRecognitionLanguage = "en-US";
        const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
        const recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);

        recognizer.recognizing = speechRecognizingFunction;
        recognizer.recognized = speechRecognizedFunction;

        recognizer.canceled = (s, e) => {
            const errorCode = e.privErrorCode;
            const errorDetails = e.privErrorDetails;
            console.log(`SPEECH CANCELED: Error=${errorCode}, ${errorDetails}`);

            recognizer.stopContinuousRecognitionAsync();
            setIsRecognizing(false);
        };

        recognizer.sessionStopped = (s, e) => {
            const reason = e?.reason || e?.privReason || e?.privErrorDetails || "Unknown";
            console.log(`SESSION STOPPED: Reason=${reason}`);

            recognizer.stopContinuousRecognitionAsync();
            setIsRecognizing(false);
        };

        recognizer.startContinuousRecognitionAsync();
        recognizerRef.current = recognizer;
        setIsRecognizing(startRecognizing);
        console.log("Recognition started...");
    };

    const stopVoiceInput = () => {
        if (recognizerRef.current) {
            recognizerRef.current.stopContinuousRecognitionAsync(() => {
                recognizerRef.current.close();
                recognizerRef.current = null;
                setIsRecognizing(false);
                console.log("Recognition stopped.");
            });
        }
    };
    // #endregion

    // #region EFFECTS FOR SPEECH RECOGNITION
    // --- Add refs for state tracking ---
    const isRecognizingRef = useRef(isRecognizing);
    const aiChatMessagesRef = useRef(aiChatMessages);
    const fileUploadRef = useRef(fileUpload);
    const aiChatFetchingReplyRef = useRef(aiChatFetchingReply);

    // Keep refs in sync with state
    useEffect(() => {
        isRecognizingRef.current = isRecognizing;
    }, [isRecognizing]);

    useEffect(() => {
        aiChatMessagesRef.current = aiChatMessages;
    }, [aiChatMessages]);

    useEffect(() => {
        fileUploadRef.current = fileUpload;
    }, [fileUpload]);

    useEffect(() => {
        aiChatFetchingReplyRef.current = aiChatFetchingReply;
    }, [aiChatFetchingReply]);

    useEffect(() => {
        if (shouldStartBuyProduct) {
            setShouldStartBuyProduct(false);
            handleBuyProduct();
        }
    }, [shouldStartBuyProduct]);

    useEffect(() => {
        if (triggerAddNewMessage) {
            const newMessage = triggerAddNewMessage;
            setTriggerAddNewMessage(null);
            addNewMessage(newMessage);
        }
    }, [triggerAddNewMessage]);

    useEffect(() => {
        if (triggerPromptAIRequest) {
            const prompt = triggerPromptAIRequest;
            setTriggerPromptAIRequest(null);
            promptAIRequest(prompt);
        }
    }, [triggerPromptAIRequest]);

    /*useEffect(() => {
        if (openBOTag) {
            setOpenBOTag(null);
            const firstGtin = BOTagsList[0]?.GTINbarcode || null;

            //console.log("Open Botag intent detected, navigating to product page...", BOTagsList, firstGtin);
            setSelectedHomePageBotagId(firstGtin);
        }
    }, [openBOTag, BOTagsList]);*/

    useEffect(() => {
        if (selectedBotag) {
            const appContext = {
                uiPage: location.pathname,
                botagIsOpen: !!selectedBotag,
                selectedBotag: selectedBotag,
                availableSizes: selectedBotag?.sizes || [],
                availableColors: selectedBotag?.colors?.map(c => c?.color) || [],

                productID: selectedBotag?.productID || selectedBotag?.data?.productObjID,
                productName: selectedBotag?.productName,
                productType: selectedBotag?.productType
            };

            console.log("appContext", appContext);
        }
    }, [selectedBotag]);

    useEffect(() => {
        setTextAreaHeight("auto");
        setTimeout(() => {
            const textArea = document.getElementsByTagName("textarea")[0];
            if (textArea) {
                const newHeight = Math.min(textArea.scrollHeight, 7 * 24);
                setTextAreaHeight(newHeight + "px");
            }
        }, 0);
    }, [userInputText]); // Adjust height on text change
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        if (!isWindowVisible) return;

        //update the first message to remove loading state after 1 second
        if (aiChatMessages.length > 0 && aiChatMessages[0].isLoadingMessage) {
            setTimeout(() => {
                setAiChatMessages(prevMessages => {
                    const updatedMessages = [...prevMessages];
                    updatedMessages[0].isLoadingMessage = false;
                    return updatedMessages;
                });
            }, 1000); // Simulate bot thinking time
        }
    }, [isWindowVisible]); // Update the first message when the chat window opens

    useEffect(() => {
        if (aiChatWindowOpen || aiChatSidePanelOpen) {
            if (aiChatMessages.length === 0) handleNewChat();
        }
    }, [aiChatWindowOpen, aiChatSidePanelOpen]); // Initialize chat if window or side panel opens

    /*useEffect(() => {
        if (newAIBotMessage) {
            const currentID = aiChatMessages.length + 1;
            const newMessage = {
                id: currentID,
                text: newAIBotMessage,
                sender: "bot",
                timestamp: new Date(),
                isLoadingMessage: false
            };
            //setAiChatMessages(prevMessages => [...prevMessages, newMessage]);
            addNewBotDelayedMessage(newMessage, 500);
            setNewAIBotMessage(null);
        }
    }, [newAIBotMessage]); // Update chat messages when new AI bot message is set*/

    useEffect(() => {
        if (replaceCurrentBotMessage) {
            const botMessageIndex = aiChatMessages.length - 1;
            if (botMessageIndex !== -1) {
                const updatedMessages = [...aiChatMessages];
                updatedMessages[botMessageIndex] = {
                    ...updatedMessages[botMessageIndex],
                    text: replaceCurrentBotMessage
                };
                setAiChatMessages(updatedMessages);
            }
            setReplaceCurrentBotMessage(null);
        }
    }, [replaceCurrentBotMessage]); // Update chat messages when replaceCurrentBotMessage is set

    useEffect(() => {
        startVoiceInput();

        return () => {
            stopVoiceInput();
        };
    }, []);

    useEffect(() => {
        /* #region METHODS FOR AI */
        const sendMessageForAI = promptText => {
            setTimeout(() => {
                const file = fileUploadRef.current;
                const fileBase64 = file ? file.file : null;
                const fileName = file ? file.fileName : null;

                const message = {
                    id: aiChatMessagesRef.current.length + 1,
                    text: promptText,
                    sender: "user",
                    timestamp: new Date(),
                    isLoadingMessage: false,
                    fileUpload: { file: fileBase64, fileName: fileName }
                };

                setTriggerAddNewMessage(message);

                const promptRequestText = {
                    message: promptText,
                    newID: aiChatMessagesRef.current.length + 2
                };
                setTriggerPromptAIRequest(promptRequestText);
            }, 100);
        };

        const processImage = async imageURL => {
            const fileName = `Photo_${Date.now()}.jpg`;
            const fileBase64 = await convertUrlToBase64(imageURL);

            if (!fileBase64) {
                Library.showToastMessage({
                    type: "error",
                    message: "Failed to convert Facebook photo to base64.",
                    autoClose: 2000
                });
                return;
            }

            return {
                file: fileBase64,
                fileName: fileName
            };
        };
        /* #endregion */

        if (AIPanelNewFacebookPhoto) {
            const file = AIPanelNewFacebookPhoto;
            const { imageURL, promptText } = file;
            setAIPanelNewFacebookPhoto(null);

            console.log(`Received new notification from Meta Rayban glasses: ${JSON.stringify(imageURL)}, prompt: ${promptText}`);

            if (promptText && imageURL)
                processImage(imageURL).then(fileGenerated => {
                    setFileUpload(fileGenerated);
                    if (promptText && promptText !== "") sendMessageForAI(promptText);
                });
            else if (imageURL) processImage(imageURL).then(fileGenerated => setFileUpload(fileGenerated));
            else if (promptText && promptText !== "") sendMessageForAI(promptText);
        }
    }, [AIPanelNewFacebookPhoto]);

    useEffect(() => {
        if (!triggerTextToSpeechMessage) return;
        textToSpeech(triggerTextToSpeechMessage);
        setTriggerTextToSpeechMessage(null);
    }, [triggerTextToSpeechMessage]);
    // #endregion

    // #region RENDER
    return (
        <StyledChatWindowContent
            className={`chat-window ${isWindowVisible() ? "isVisible" : "isHidden"} ${
                isSidePanelFullScreen ? "full-screen" : ""
            } library-scrollable`}>
            <FullScreenLoader isLoading={aiChatLoading} />

            <div className="b-otag-ai-chat-widget">
                <div className="frame-1000011421">
                    <div className="group-2">
                        <div className="divlabel">
                            <span className="label-span2">AI</span>
                        </div>
                        <img className="exclusion-7" src={botagIcon} alt="botag-icon-purple.svg" />
                    </div>
                    <div className="frame-1000011450">
                        <div className="frame-110 d-none">
                            <ChatDropdown
                                setShowChatConversation={setShowChatConversation}
                                setShowChatAllPanel={setShowChatAllPanel}
                                updateAIchatRequest={updateAIchatRequest}
                                handleNewChat={handleNewChat}
                            />
                        </div>
                        <div className="frame-113 cursor-pointer" onClick={handleNewChat}>
                            <RefreshIcon className="component-1 text-normal" />
                        </div>
                        <div className="frame-112">
                            <img className="x-close cursor-pointer" src={XCloseIcon} onClick={handleCloseChat} alt="Close Chat" />
                        </div>
                    </div>
                </div>
                <div className="all-messages-container">
                    {showDeleteDialog && <DialogBox setShowDeleteDialog={setShowDeleteDialog} />}

                    {showChatConversation ? (
                        aiChatMessages.map((message, index) => (
                            <MessageContainer
                                id={`chat-message-${message.id}`}
                                key={message.id}
                                message={message}
                                sender={message.sender}
                                text={message.text}
                                timestamp={message.timestamp}
                                isLoadingMessage={message.isLoadingMessage}
                                loadingPlaceholder={message.loadingPlaceholder}
                                isNew={index === aiChatMessages.length - 1} // Mark the last message as new
                                fileUpload={message.fileUpload}
                            />
                        ))
                    ) : showChatAllPanel ? (
                        <AllChatsPanel setShowDeleteDialog={setShowDeleteDialog} />
                    ) : null}
                </div>
                <div className="frame-1000011416">
                    {fileUpload && fileUpload.file ? (
                        <div className="frame-1000011411">
                            <div className="frame-1000011407">
                                <div className="frame-10000114232" /*onClick={previewPhotoPopup}*/>
                                    <img className="file-06" src={fileUpload?.file} alt="file" />
                                </div>
                                <div className="frame-1000011422 d-none">
                                    <div className="replay-xlsx">{fileUpload.fileName || "Uploaded File"}</div>
                                    <div className="file">Image</div>
                                </div>
                            </div>
                            <div className="frame-1000011448">
                                <XCloseIcon2 className="x-close2" onClick={removeFileUpload} alt="Close File" />
                            </div>
                        </div>
                    ) : null}

                    <div className="frame-10000114072">
                        <div className="frame-111 cursor-pointer" onClick={handleUploadClick}>
                            <img className="paperclip" src={paperclipIcon} alt="paperclip0.svg" />

                            <input
                                id="file-upload-input"
                                name="file-upload-input"
                                type="file"
                                className="hidden"
                                accept=".jpg, .jpeg, .png, .gif, .bmp, .tiff, .webp"
                                multiple={false}
                                //capture="environment" // Uncomment to directly open camera on mobile devices
                                onChange={e => {
                                    if (!e.target.files || e.target.files.length === 0) return;
                                    handleFileChange(e.target.files[0]);
                                }}
                            />
                        </div>

                        <div className="frame-111 cursor-pointer" onClick={handleCameraClick}>
                            <Camera01 className="paperclip" />
                        </div>

                        <div
                            className={`frame-111 cursor-pointer ${isRecognizing ? "active" : ""} ${
                                isRecognizing && aiChatFetchingReply ? "stop-listening" : ""
                            }  mr-4px`}
                            //onClick={isRecognizing ? stopVoiceInput : startVoiceInput}
                            onClick={() => {
                                if (!isRecognizing) startVoiceInput(true);
                                else setIsRecognizing(false);
                            }}
                            style={{ padding: "9px" }}>
                            {isRecognizing && !aiChatFetchingReply ? (
                                <Microphone01 className="microphone" />
                            ) : (
                                <MicrophoneOff01 className="microphone-off" />
                            )}
                        </div>

                        <textarea
                            className="text-user"
                            placeholder="Ask me anything..."
                            onChange={e => {
                                if (aiChatFetchingReply) return;
                                setUserInputText(e.target.value);
                                //setTextAreaHeight(Math.min(e.target.scrollHeight, 7 * 24) + "px");
                            }}
                            value={userInputText}
                            rows={1}
                            style={{
                                resize: "none",
                                overflow: "auto",
                                maxHeight: 17 * 7,
                                minHeight: "auto",
                                height: textAreaHeight || "auto"
                            }}
                            onKeyDown={e => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    userAddNewMessage();
                                    //setTextAreaHeight(Math.min(e.target.scrollHeight, 7 * 24) + "px");
                                }
                            }}
                        />
                        <div
                            className={`frame-1102 ${aiChatFetchingReply ? "cursor-not-allowed" : "cursor-pointer"}`}
                            onClick={userAddNewMessage}>
                            <img
                                className="arrow-narrow-up"
                                src={aiChatFetchingReply ? stopCircleIcon : arrowNarrowUpIcon}
                                alt="arrow-narrow-up0.svg"
                            />
                        </div>
                    </div>

                    <div className="powered-by-chat-gpt">Powered by OpenAI</div>
                </div>
            </div>
            {previewPhoto && (
                <FullScreenOverlay>
                    <TakePhoto
                        previewPhoto={fileUpload?.preview}
                        previewPhotoBlob={fileUpload?.file}
                        onPhotoSelected={() => setPreviewPhoto(null)}
                    />
                </FullScreenOverlay>
            )}
        </StyledChatWindowContent>
    );
    // #endregion
}

// #region SMALL COMPONENTS
const MessageContainer = ({ sender, text, timestamp, isNew, isLoadingMessage, loadingPlaceholder, id, fileUpload }) => {
    const userIcon = sender === "bot" ? botagIconPurpleContainer : null;
    const ballonPaddingY = sender === "bot" ? "18px" : "10px";

    const cleanedText = text.replace(/【\d+:\d+†[^†]+】/g, ""); // Remove the pattern 【4:0†store_enrollment_v5.md】

    return (
        <div className={`message-container ${sender} ${isNew ? "new-message" : "old-message"} ${id}`}>
            <div className="flex" style={{ flexDirection: "column", gap: "8px" }}>
                {fileUpload && fileUpload.file && (
                    <div
                        className="frame-1000011407"
                        style={{
                            maxWidth: "200px",
                            alignSelf: "end"
                        }}>
                        <div className="frame-10000114232">
                            <img className="file-06" src={fileUpload?.file} alt="file" />
                        </div>
                        <div className="frame-1000011422 d-none">
                            <div className="replay-xlsx">{fileUpload.fileName || "Uploaded File"}</div>
                            <div className="file">Image</div>
                        </div>
                    </div>
                )}

                <div className="message-date-container">
                    <img className={`user-icon ${sender} ${!userIcon ? "hidden" : ""}`} src={userIcon} alt="user-icon" />
                    <div className="message-date-container-sized">
                        <div className="message-ballon" style={{ paddingTop: ballonPaddingY, paddingBottom: ballonPaddingY }}>
                            {isLoadingMessage ? (
                                <div className="message-text-style flex">
                                    <div className="message-loading">
                                        <span className="message-loading-dot"></span>
                                        <span className="message-loading-dot"></span>
                                    </div>
                                    <div className="loading-text">{loadingPlaceholder || "processing"}</div>
                                </div>
                            ) : (
                                <div className="message-text-style">
                                    <ReactMarkdown>{cleanedText}</ReactMarkdown>
                                </div>
                            )}
                        </div>
                        <div className="message-datetime">
                            <div className="message-datetime-style">{formatDefaultDateTime(timestamp)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ChatDropdown = ({ setShowChatConversation, setShowChatAllPanel, updateAIchatRequest, handleNewChat }) => {
    const { aiChatCurrentThreadID, setAiChatCurrentThreadID } = useContext(AppContext);

    return (
        <StyledChatWindowContent>
            <Dropdown
                trigger={["click"]}
                menu={{
                    items: [
                        {
                            key: "1",
                            label: <DropdownItem label="New Chat" onClick={handleNewChat} imgSrc={EditIcon} />
                        },
                        {
                            key: "2",
                            label: (
                                <DropdownItem
                                    label="Archive this chat"
                                    onClick={() => {
                                        if (!aiChatCurrentThreadID) {
                                            Library.showToastMessage({
                                                type: "warning",
                                                message: "No chat to archive.",
                                                autoClose: 2000
                                            });
                                            return;
                                        }

                                        updateAIchatRequest(aiChatCurrentThreadID, null, "archived").then(res => {
                                            if (!res) {
                                                Library.showToastMessage({
                                                    type: "error",
                                                    message: "Failed to archive chat.",
                                                    autoClose: 2000
                                                });
                                                return;
                                            } else {
                                                Library.showToastMessage({
                                                    type: "success",
                                                    message: "Chat archived successfully.",
                                                    autoClose: 2000
                                                });
                                            }
                                            setAiChatCurrentThreadID(null);
                                            setShowChatConversation(false);
                                            setShowChatAllPanel(true);
                                        });
                                    }}
                                    imgSrc={ArchiveIcon}
                                />
                            )
                        },
                        {
                            key: "3",
                            label: (
                                <DropdownItem
                                    label="Leave Chat"
                                    onClick={() => {
                                        setShowChatConversation(false);
                                        setShowChatAllPanel(true);
                                    }}
                                    imgSrc={LogoutIcon}
                                />
                            )
                        }
                    ]
                }}
                className="cursor-pointer Dropdown-menu-2"
                overlayStyle={{
                    zIndex: 99999,
                    marginTop: "8px",
                    width: "161px"
                }}
                overlayClassName="dropdown-regular"
                style={{
                    top: "10px"
                    //zIndex: 99999,
                }}
                placement="bottom">
                <img className="dots-horizontal" src={DotsHorizontalIcon} alt="dots-horizontal0.svg" />
            </Dropdown>
        </StyledChatWindowContent>
    );
};

const DropdownItem = ({ label, onClick, imgSrc }) => {
    return (
        <StyledChatWindowContent className="frame-79" onClick={onClick}>
            {imgSrc && <img className="edit-05" src={imgSrc} alt="img" />}
            <div className="new-chat">{label}</div>
        </StyledChatWindowContent>
    );
};

const DialogBox = ({ setShowDeleteDialog }) => {
    return (
        <StyledDialogue className="dialog-box">
            <div className="frame-257">
                <div className="attention">ATTENTION</div>
                <div className="line-4"></div>
                <div className="frame-258">
                    <div className="frame-285">
                        <div className="frame-160">
                            <div className="frame-286">
                                <div className="ready-to-delete">Delete Chat</div>
                            </div>
                            <div className="it-will-be-gone-forever">Are you sure you want to delete this chat?</div>
                        </div>
                        <div className="frame-255">
                            <div
                                className="btn-large-solid-inverted-01"
                                onClick={() => {
                                    setShowDeleteDialog(false);
                                }}>
                                <div className="btn-small-filled">
                                    <div className="share">NO</div>
                                </div>
                            </div>
                            <div
                                className="btn-large-solid-inverted-01"
                                onClick={() => {
                                    setShowDeleteDialog(false);
                                }}>
                                <div className="btn-small-filled">
                                    <div className="share">YES</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </StyledDialogue>
    );
};
// #endregion
